import { useState } from 'react'

import Link from 'next/link'
import Markdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'

import { parseContentToMarkdown, PROFILE_PATH_REG } from '@/utils/parsedContent'
import { cn } from '@/utils/cn'
import useIsMobile from '@/hooks/useIsMobile'

import styles from './styles.module.css'

export interface ContentParsedProps {
  content: string
  className?: string
  isContentEvent?: boolean
}

export const ContentParsed: React.FC<ContentParsedProps> = (props: ContentParsedProps) => {
  const isMobile = useIsMobile()
  const [readMore, setReadMore] = useState<boolean>(false)
  const MAX_WORDS = isMobile ? 120 : 200
  const LINES = props.content.split('\n')

  return (
    <div>
      <Markdown
        remarkPlugins={[remarkBreaks]}
        className={cn(`break-words text-sm`, props.className, styles.markdown, {
          'line-clamp-3': !readMore,
          'max-w-[278px] sm:max-w-none': !props.isContentEvent,
        })}
        /* eslint-disable-next-line react/no-children-prop */
        children={parseContentToMarkdown(props.content)}
        components={{
          a(props: any) {
            const { children, href } = props
            const isTagComment = PROFILE_PATH_REG.test(href)

            return isTagComment ? (
              <Link
                href={href}
                target="_blank"
                style={{
                  fontWeight: 600,
                  color: '#6C5DD3',
                }}
              >
                {children}
              </Link>
            ) : (
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                style={{
                  fontWeight: 600,
                  color: '#6C5DD3',
                  textDecoration: 'underline',
                }}
                className="break-words"
              >
                {children}
              </a>
            )
          },
          // p(props: any) {
          //   const { children, node, ...rest } = props;

          //   return <p>{children}</p>;
          // }
        }}
      />

      {!readMore && (props.content.length > MAX_WORDS || LINES.length > 3) && (
        <button onClick={() => setReadMore(true)} className="text-sm font-medium text-ss-primary text-left">
          Read more
        </button>
      )}
    </div>
  )
}
